import React from 'react';
import ReportPage from './components/ReportPage';
import SLAsByCompaniesList from './components/SLAsByCompaniesList';

function SLAsByCompanies() {
  return (
    <ReportPage title="SLAs by companies">
      <SLAsByCompaniesList />
    </ReportPage>
  );
}

export default SLAsByCompanies;
